import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErreurApi } from './api/client';
import { App } from './App';
import { FournisseurAuth } from './auth/AuthContext';
import { FournisseurToasts } from './composants/Toasts';
import './styles.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (tentative, erreur) => {
        // Inutile de réessayer une erreur de saisie ou une session expirée :
        // seules les pannes réseau et serveur méritent une seconde chance.
        if (erreur instanceof ErreurApi && erreur.statut >= 400 && erreur.statut < 500) return false;
        return tentative < 2;
      },
    },
    mutations: { retry: false },
  },
});

/*
 * Un champ date ouvre son calendrier au clic, où que l'on clique.
 *
 * Par défaut, seul le petit pictogramme à droite l'ouvre ; le reste du champ
 * ne fait que placer le curseur sur le jour, le mois ou l'année. Écouté une
 * fois pour toute l'application : chaque champ date, présent ou à venir, en
 * profite sans qu'on ait à y penser.
 */
document.addEventListener('click', (e) => {
  const champ = e.target;
  if (!(champ instanceof HTMLInputElement) || champ.type !== 'date') return;
  if (champ.disabled || champ.readOnly) return;
  try {
    champ.showPicker();
  } catch {
    // Navigateur sans `showPicker`, ou calendrier déjà ouvert : le pictogramme
    // reste là.
  }
});

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine introuvable dans index.html');

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <FournisseurToasts>
        <FournisseurAuth>
          <App />
        </FournisseurAuth>
      </FournisseurToasts>
    </QueryClientProvider>
  </StrictMode>,
);
